import {TrustStatus} from '@sollapay/enums';

import {TRUST_PURPOSE_CONFIG} from './trust-accounts.config';

import type {TrustPurposeConfig} from './trust-accounts.config';
import type {TrustAccountCreatedAtFilter, TrustAccountFilterState} from '../utils/filter.utils';
import type {TrustPurpose} from '@sollapay/enums';
import type {FirmTrustAccountListItemDTO} from '@sollapay/types';

/** Where an account keeps the name the search matches and the date the date filter reads. */
export interface TrustAccountFilterFields<T> {
  getName: (account: T) => string;
  getDate: (account: T) => string | Date;
}

export const FIRM_ACCOUNT_FILTER_FIELDS: TrustAccountFilterFields<FirmTrustAccountListItemDTO> = {
  getName: account => account.name,
  getDate: account => account.createdAt
};

export const DEFAULT_FILTER_STATE: TrustAccountFilterState = {
  statuses: [],
  purposes: [],
  createdAt: 'all'
};

export const TRUST_STATUS_FILTER_OPTIONS: ReadonlyArray<{
  value: TrustStatus;
  i18nKey: string;
}> = [
  {value: TrustStatus.SETUP_IN_PROGRESS, i18nKey: 'statuses.setupInProgress'},
  {value: TrustStatus.PENDING_VALIDATION, i18nKey: 'statuses.pendingValidation'},
  {value: TrustStatus.IN_REVIEW, i18nKey: 'statuses.inReview'},
  {value: TrustStatus.CLARIFICATION_REQUIRED, i18nKey: 'statuses.clarificationRequired'},
  {value: TrustStatus.ACTIVATION_PENDING, i18nKey: 'statuses.activationPending'},
  {value: TrustStatus.TRUST_ACTIVE, i18nKey: 'statuses.trustActive'}
];

export const TRUST_PURPOSE_FILTER_OPTIONS: ReadonlyArray<{
  value: TrustPurpose;
  i18nKey: string;
}> = (Object.entries(TRUST_PURPOSE_CONFIG) as Array<[TrustPurpose, TrustPurposeConfig]>)
  .filter(([, {hidden}]) => !hidden)
  .map(([value, {labelKey}]) => ({value, i18nKey: labelKey}));

export const CREATED_AT_FILTER_OPTIONS: ReadonlyArray<{
  value: TrustAccountCreatedAtFilter;
  i18nKey: string;
}> = [
  {value: 'all', i18nKey: 'filter.createdAt.all'},
  {value: '7d', i18nKey: 'filter.createdAt.last7days'},
  {value: '30d', i18nKey: 'filter.createdAt.last30days'},
  {value: '90d', i18nKey: 'filter.createdAt.last90days'}
];
